import React, { useEffect } from 'react';
import { useRef, useState } from "react";
import style from "./props.module.sass";
import { AppState } from '../../../../../../stateManager/store';
import { useSelector } from 'react-redux';

interface ITextValidation {
    value: string,
    canEdit?: boolean,
    onChange?: (val: any) => void,
    dataTestId?: string;
    placeholder?: string
}
const I18AutoCompletion = (props: ITextValidation) => {
    const { value="", dataTestId } = props
    const [i18nVal, setI18nVal] = useState(value)
    const spansRefs: any = useRef([]);
    const [showError, setShowError] = useState(false);
    const [backKeyPress, setBackKeyPress] = useState(false)
    const { version: formVersion } = useSelector(
        (state: AppState) => state.formJson
    );

    const handleInput = (event: any, index: number) => {
        const currentSpan = spansRefs.current[index];
        const nextSpan = spansRefs.current[index + 1];
        const previousSpan = spansRefs.current[index - 1];

        if (spansRefs?.current[1]?.outerText !== "") {
            setShowError(false)
        }

        if (spansRefs?.current[0]?.outerText === ("$i18n.") || spansRefs.current[0]?.outerText !== "") {
            setShowError(false)
        } else {
            setShowError(true)
        }

        if (backKeyPress) {
            if (currentSpan.textContent === "" && previousSpan && index === 1 && spansRefs.current[0]?.textContent?.length >= 6) {
                event.preventDefault();
                previousSpan.focus();
                placeCursorAtEnd(previousSpan);
            }
        }

        if (!backKeyPress) {
            if (currentSpan.textContent.length >= 6 && index === 0 && nextSpan) {
                event.preventDefault();
                nextSpan.focus();
            }
        }

        const final = spansRefs.current[0]?.textContent + spansRefs.current[1]?.textContent
    };

    const placeCursorAtEnd = (element: any) => {
        const range = document.createRange();
        const selection: any = window.getSelection();
        range.selectNodeContents(element);
        range.collapse(false);
        selection.removeAllRanges();
        selection.addRange(range);
    };

    const handleSpanRef = (ref: any, index: number) => {
        spansRefs.current[index] = ref;
    };

    const handleKeyPress = (event: any, index: number) => {
        const previousSpan = spansRefs.current[index - 1];
        const nextSpan = spansRefs.current[index + 1];
        const currentSpan = spansRefs.current[index];

        if (spansRefs?.current[1]?.textContent === "" || spansRefs?.current[0]?.textContent === "") {
            setShowError(true);
        } else {
            setShowError(false);
        }

        if (event.key === "Backspace") {
            setBackKeyPress(true)
            if (currentSpan.textContent === "" && previousSpan && index === 1) {
                event.preventDefault();
                previousSpan.focus();
                placeCursorAtEnd(previousSpan);
            }
        } else {
            setBackKeyPress(false)
            if (currentSpan.textContent.length >= 6 && index === 0 && nextSpan) {
                event.preventDefault();
                nextSpan.focus();
            }
        }

        if (event.key === "ArrowRight" && nextSpan) {
            event.preventDefault();
            nextSpan.focus();
            placeCursorAtEnd(nextSpan);
        }

        if (event.key === "ArrowLeft" && previousSpan) {
            event.preventDefault();
            previousSpan.focus();
            placeCursorAtEnd(previousSpan);
        }
    };

    return (
        <div className="i18nautocomplete" style={{ border: formVersion === "v2" ? "1px solid #7D84924B" : "1px solid #95ABD3", borderRadius: formVersion === "v2" ? "2px" : "4px", background: "#ffffff" }}>
            <div style={{ height: "100%", display: "flex", alignItems: 'center', overflow: "hidden" }}
                className={style.i18nDisableSelection}
                data-test-id={dataTestId}
                placeholder={props.placeholder && props.placeholder}>
                <span
                    className={style.i18nDisableSelection}
                    style={{
                        border: "none",
                        outline: "none",
                        background: showError ? "rgba(255, 217, 215, .4)" : value.includes("$i18n.") ? "rgba(219, 243, 205, .4)" : (value !== "$i18n." || spansRefs?.current[0]?.textContent !== "$i18n.") ? "#FFFFFF" : "rgba(219, 243, 205, .4)",
                        color: showError ? " #ff8f87" : value.includes("$i18n.") ? "#22a21f" : (value !== "$i18n." || spansRefs?.current[0]?.textContent !== "$i18n.") ? formVersion === "v2" ? "#000000" : "#0466C8" : "#22a21f"
                    }}
                    onInput={(event) => handleInput(event, 0)}
                    onKeyDown={(event: any) => { handleKeyPress(event, 0) }}
                    ref={(ref) => handleSpanRef(ref, 0)}
                    contentEditable={true}
                >
                    {value.startsWith("$i18n.") ? value.split(".")[0] + "." : value}
                </span>
                <span
                    style={{
                        border: "none",
                        outline: "none",
                        background: showError ? "rgba(255, 217, 215, .4)" : value.includes("$i18n.") ? "rgba(219, 243, 205, .4)" : spansRefs?.current[1]?.textContent !== "$i18n." ? "#FFFFFF" : "rgba(219, 243, 205, .4)",
                        color: showError ? " #ff8f87" : value.includes("$i18n.") ? "#063fa9" : spansRefs?.current[1]?.textContent !== "$i18n." ? "#000000" : "#063fa9"
                    }}
                    onKeyDown={(event: any) => { handleKeyPress(event, 1) }}
                    onInput={(event) => handleInput(event, 1)}
                    ref={(ref) => handleSpanRef(ref, 1)}
                    contentEditable={true}
                >
                    {value.startsWith("$i18n.") ? value.split(".")[1] : ""}
                </span>
            </div>
        </div>
    );
}
export default I18AutoCompletion;